export async function getFilesFromURLs(urls: string[], filenames: string[]) {
    const files = await Promise.all(
      urls.map(async (url, index) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return new File([blob], filenames[index], { type: blob.type });
      })
    );
    return files;
}
